import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  flex: 1;
`;

export const copyButtonStyle = css`
  svg {
    flex-shrink: 0;
  }
`;

export const patronIdStyle = css`
  display: inline-flex;
  font-weight: 100;
  background-color: ${theme.colors.neutral5};
  border: 1px solid ${theme.colors.neutral5};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(0, 0.5)};
  max-width: 70px;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
